
try{

(()=>{
'use strict';
const reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
const motionButton=document.querySelector('.motion-toggle');
let motionOff=reduce.matches;
function setMotion(off){motionOff=off;document.body.classList.toggle('motion-off',off);motionButton.textContent=off?'Enable motion':'Pause motion';motionButton.setAttribute('aria-pressed',String(off));}
setMotion(motionOff);
motionButton.addEventListener('click',()=>setMotion(!motionOff));
reduce.addEventListener?.('change',event=>setMotion(event.matches));
if('IntersectionObserver' in window){
 document.body.classList.add('motion-ready');
 const observer=new IntersectionObserver(entries=>{for(const entry of entries){if(entry.isIntersecting){entry.target.classList.add('visible');observer.unobserve(entry.target);}}},{threshold:.08,rootMargin:'0px 0px -20px 0px'});
 document.querySelectorAll('.reveal').forEach(el=>observer.observe(el));
 // Repeat only the small mark and CTA while the opening section is in view.
 const opening=document.querySelector('.hero');
 const openingObserver=new IntersectionObserver(entries=>{for(const entry of entries){document.body.classList.toggle('hero-away',!entry.isIntersecting);}},{threshold:0});
 openingObserver.observe(opening);
}
function syncPageVisibility(){document.body.classList.toggle('page-away',document.hidden);}
syncPageVisibility();
document.addEventListener('visibilitychange',syncPageVisibility);
const menu=document.querySelector('.menu-button'),nav=document.querySelector('.nav-links');
function closeMenu(){nav.classList.remove('open');menu.setAttribute('aria-expanded','false');menu.setAttribute('aria-label','Open menu');}
menu.addEventListener('click',()=>{const open=menu.getAttribute('aria-expanded')!=='true';nav.classList.toggle('open',open);menu.setAttribute('aria-expanded',String(open));menu.setAttribute('aria-label',open?'Close menu':'Open menu');});
nav.querySelectorAll('a').forEach(a=>a.addEventListener('click',closeMenu));
document.addEventListener('keydown',e=>{if(e.key==='Escape'&&nav.classList.contains('open')){closeMenu();menu.focus();}});

})();

}catch(e){console.warn("[mdp] block skipped:",e&&e.message)}

;

try{

// Illustrative niche switcher: no data is sent or stored.
(()=>{const choices=Array.from(document.querySelectorAll('[data-concept]'));function activate(button,focus=false){choices.forEach(c=>{const selected=c===button;c.setAttribute('aria-selected',String(selected));c.tabIndex=selected?0:-1;document.getElementById(c.getAttribute('aria-controls')).hidden=!selected;});if(focus)button.focus();}choices.forEach((c,i)=>{c.addEventListener('click',()=>activate(c));c.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=(i+1)%choices.length;else if(e.key==='ArrowLeft')n=(i+choices.length-1)%choices.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=choices.length-1;if(n!==undefined){e.preventDefault();activate(choices[n],true);}});});})();

}catch(e){console.warn("[mdp] block skipped:",e&&e.message)}

;

try{

(()=>{
 const copies=document.getElementById('scenario-copies'),price=document.getElementById('scenario-price');
 const wholeCurrency=new Intl.NumberFormat('en-IE',{style:'currency',currency:'EUR',maximumFractionDigits:0});
 const decimalCurrency=new Intl.NumberFormat('en-IE',{style:'currency',currency:'EUR',minimumFractionDigits:2,maximumFractionDigits:2});
 const outputs=['creator-share','mdp-share','scenario-net'];
 function calculate(){
  const count=copies.valueAsNumber,unit=price.valueAsNumber;
  const validCount=Number.isInteger(count)&&count>=0&&count<=100000,validPrice=Number.isFinite(unit)&&unit>=0&&unit<=10000;
  copies.setAttribute('aria-invalid',String(!validCount));price.setAttribute('aria-invalid',String(!validPrice));
  const error=document.getElementById('scenario-error');
  document.getElementById('scenario-count-label').textContent=validCount?String(count):'your';
  if(!validCount||!validPrice){outputs.forEach(id=>document.getElementById(id).textContent='—');error.hidden=false;error.textContent='Enter a whole number of copies and a valid net amount.';return;}
  const net=count*Math.round(unit*100),creator=Math.round(net*.7);error.hidden=true;
  [creator,net-creator,net].forEach((amount,i)=>document.getElementById(outputs[i]).textContent=(amount%100===0?wholeCurrency:decimalCurrency).format(amount/100));
 }
 [copies,price].forEach(el=>el.addEventListener('input',calculate));calculate();
 const form=document.getElementById('contact-form'),username=document.getElementById('creator-profile'),review=document.getElementById('form-status');
 username.addEventListener('input',()=>{review.hidden=true;username.setCustomValidity('');});
 const question=document.getElementById('creator-question');
 question.addEventListener('input',()=>{review.hidden=true;});
 document.querySelectorAll('input[name="platform"]').forEach(radio=>radio.addEventListener('change',()=>{review.hidden=true;}));
 const emailCta=document.getElementById('email-cta');
 const MAILTO='partnerships@mydigitalproduct.co';
 function draft(){
  const value=username.value.trim().replace(/^@/,'');
  if(!value)return 'mailto:'+MAILTO;
  const platform=(document.querySelector('input[name="platform"]:checked')||{}).value||'Instagram';
  const msg=question.value.trim();
  const subject='Partnership enquiry \u2014 @'+value+' ('+platform+')';
  const body=['Platform: '+platform,'Username: @'+value,'',msg?('Question:\n'+msg):'Question: \u2014','','Sent from the MyDigitalProduct site.'].join('\n');
  return 'mailto:'+MAILTO+'?subject='+encodeURIComponent(subject)+'&body='+encodeURIComponent(body);
 }
 function refresh(){if(emailCta)emailCta.setAttribute('href',draft());}
 [username,question].forEach(el=>el.addEventListener('input',refresh));
 document.querySelectorAll('input[name="platform"]').forEach(rd=>rd.addEventListener('change',refresh));
 refresh();
 function validate(){
  const value=username.value.trim().replace(/^@/,'');
  if(!value||/[\s/@:?#]/u.test(value)){
   username.setCustomValidity('Enter a username, not a profile link.');username.reportValidity();return false;}
  username.setCustomValidity('');
  return form.reportValidity();
 }
 if(emailCta)emailCta.addEventListener('click',e=>{
  if(!validate()){e.preventDefault();return;}
  emailCta.setAttribute('href',draft());
  review.replaceChildren();
  const p=document.createElement('p');
  p.textContent='Opening your mail app to '+MAILTO+'\u2026';
  review.appendChild(p);review.hidden=false;
 });
 /* Fardigskrivna forslag: ett klick fyller rutan. */
 document.querySelectorAll('[data-ask]').forEach(chip=>chip.addEventListener('click',()=>{
  question.value=chip.dataset.ask;
  document.querySelectorAll('[data-ask]').forEach(c=>c.setAttribute('aria-pressed',String(c===chip)));
  refresh();review.hidden=true;
  try{question.focus({preventScroll:true});}catch(e){}
 }));
 question.addEventListener('input',()=>{
  document.querySelectorAll('[data-ask]').forEach(c=>c.setAttribute('aria-pressed','false'));});

 /* Huvudhandlingen ar att SKICKA. Pa den publicerade sajten gors detta av
    Shopifys eget kontaktformular, som mejlar butiksadressen. Den fristaende
    filen kan inte skicka - Shopify svarar 403 pa en POST fran annan origin -
    och da sager statusraden det i stallet for att ljuga om en skickad fraga. */
 form.addEventListener('submit',e=>{
  e.preventDefault();
  if(!validate())return;
  const value=username.value.trim().replace(/^@/,'');
  review.replaceChildren();
  const p1=document.createElement('p');
  p1.innerHTML='Thanks &mdash; <strong>@'+value.replace(/[<>&]/g,'')+'</strong> is on its way to us.';
  review.appendChild(p1);
  const p2=document.createElement('p');
  p2.className='review-question';
  p2.textContent='In this preview nothing is sent yet: submission is wired when the page goes live. Use Instagram DM or email below meanwhile.';
  review.appendChild(p2);
  review.hidden=false;
 });
})();

}catch(e){console.warn("[mdp] block skipped:",e&&e.message)}

;

try{

/* Staggrade gruppinsteg och rakneverk for de tva andelssiffrorna och grundarens ar.
   Egen observator sa script 1 lamnas orort. Siffrornas slutvarde star redan i HTML:en
   och skrivs tillbaka ordagrant nar rakneverket ar klart - kors rAF aldrig (pausad
   flik, reducerad rorelse, gammal webblasare) star det exakta talet kvar. */
(()=>{'use strict';
 const reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
 const still=()=>reduce.matches||document.body.classList.contains('motion-off');
 const groups=Array.from(document.querySelectorAll('[data-stagger]'));
 groups.forEach(g=>{const step=Number(g.dataset.stagger)||70;
  Array.from(g.children).forEach((c,i)=>c.style.setProperty('--delay',Math.min(i*step,640)+'ms'));});

 function countUp(el){
  if(el.dataset.counted)return;el.dataset.counted='1';
  const node=Array.from(el.childNodes).find(n=>n.nodeType===3&&n.textContent.trim());
  if(!node)return;
  const finalText=node.textContent,digits=finalText.replace(/\D/g,'');
  const target=parseInt(digits,10);
  if(!Number.isFinite(target)||target<2||target>10000)return;
  const prefix=finalText.match(/^\D*/)[0],suffix=finalText.slice(prefix.length+digits.length);
  /* Siffran far ALDRIG sta kvar pa ett mellanvarde. requestAnimationFrame stryps
     eller stannar i en bakgrundsflik, sa ett rakneverk som bara litar pa rAF kan
     frysa mitt i och visa ett falskt tal. Darfor tre oberoende utgangar tillbaka
     till exakt slutvarde: en timeout som backstopp, visibilitychange nar fliken
     goms, och kontroll i varje bildruta. */
  const settle=()=>{node.textContent=finalText;};
  if(still()||document.hidden){settle();return;}
  const dur=850;let done=false;
  const finish=()=>{if(done)return;done=true;settle();document.removeEventListener('visibilitychange',onHide);};
  function onHide(){if(document.hidden)finish();}
  document.addEventListener('visibilitychange',onHide);
  setTimeout(finish,dur+250);
  const start=performance.now();
  (function frame(now){
   if(done)return;
   if(still()||document.hidden){finish();return;}
   const p=Math.min((now-start)/dur,1);
   if(p>=1){finish();return;}
   node.textContent=prefix+Math.round(target*(1-Math.pow(1-p,3)))+suffix;
   requestAnimationFrame(frame);
  })(start);
 }

 const counters=Array.from(document.querySelectorAll('[data-countup]'));
 if(!('IntersectionObserver' in window)){counters.forEach(c=>c.dataset.counted='1');return;}
 const io=new IntersectionObserver(entries=>{for(const e of entries){if(!e.isIntersecting)continue;
   e.target.classList.add('visible');io.unobserve(e.target);
   if(e.target.hasAttribute('data-countup'))countUp(e.target);}},
  {threshold:.12,rootMargin:'0px 0px -40px 0px'});
 groups.concat(counters).forEach(el=>io.observe(el));

 /* En fordjupning som oppnas ska kaskada, inte dimpa ned fardig. */
 document.querySelectorAll('details.read-more').forEach(d=>d.addEventListener('toggle',()=>{
  if(!d.open)return;
  d.querySelectorAll('[data-stagger]').forEach(g=>{g.classList.remove('visible');void g.offsetWidth;g.classList.add('visible');});
 }));
})();

}catch(e){console.warn("[mdp] block skipped:",e&&e.message)}

;

try{

/* Konceptprodukterna: flikar, gatad handling, trial-vagg och en riktig
   interaktion per app. Varje harledd siffra RAKNAS, aldrig hardkodas - varje
   handler kor sin sync vid start, sa det som star i markupen ar bara ett
   fallback for en sida utan JS och maste darfor ocksa stamma.
   Tillstandsmaskinen kor pa setTimeout, inte rAF, och hoppar direkt till
   slutlaget om rorelsen ar av eller sidan ar gomd: ett halvvags fryst
   mellansteg far aldrig bli det besokaren ser. */
(()=>{'use strict';
 const reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
 const still=()=>reduce.matches||document.body.classList.contains('motion-off');
 const eur=c=>'€'+(c/100).toLocaleString('en-IE',{minimumFractionDigits:c%100?2:0,maximumFractionDigits:c%100?2:0});
 const whole=c=>'€'+Math.round(c/100).toLocaleString('en-IE');
 const pct=(a,b)=>Math.max(0,Math.min(100,a/b*100)).toFixed(1)+'%';

 /* ---------- delad stomme: vyer, flikar, vagg ---------- */
 document.querySelectorAll('.app-frame').forEach(frame=>{
  const views=Array.from(frame.querySelectorAll('.app-view'));
  const tabs=Array.from(frame.querySelectorAll('.app-tabs button'));
  const offer=frame.querySelector('[data-offer]');
  if(!views.length)return;
  const home=views[0].dataset.view;
  let timers=[];
  const clear=()=>{timers.forEach(clearTimeout);timers=[];};
  const later=(fn,ms)=>timers.push(setTimeout(fn,ms));
  const show=n=>{views.forEach(v=>{v.hidden=v.dataset.view!==n;});
   tabs.forEach(t=>t.setAttribute('aria-current',String(t.dataset.tab===n)));};
  const scansEl=frame.querySelector('[data-scans-left]');
  const copyEl=frame.querySelector('[data-scan-copy]');
  const resetScans=()=>{if(scansEl)scansEl.textContent='3';};
  const resetCopy=()=>{if(copyEl)copyEl.textContent='Point at your plate';};
  tabs.forEach(t=>t.addEventListener('click',()=>{clear();resetScans();resetCopy();show(t.dataset.tab);}));

  let lastFocus=null;
  const openOffer=()=>{if(!offer)return;lastFocus=document.activeElement;offer.hidden=false;
   const c=offer.querySelector('[data-offer-close]');if(c){try{c.focus({preventScroll:true});}catch(e){c.focus();}}};
  const closeOffer=()=>{if(!offer)return;offer.hidden=true;clear();resetScans();resetCopy();show(home);
   if(lastFocus&&document.contains(lastFocus)){try{lastFocus.focus({preventScroll:true});}catch(e){}}};
  if(offer){
   const c=offer.querySelector('[data-offer-close]');if(c)c.addEventListener('click',closeOffer);
   /* Avsiktligt overksam: ingen kassa, inget konto. Knappen stanger bara. */
   const cta=offer.querySelector('[data-offer-cta]');if(cta)cta.addEventListener('click',closeOffer);
   frame.addEventListener('keydown',e=>{if(e.key==='Escape'&&!offer.hidden){e.preventDefault();closeOffer();}});
  }
  frame.querySelectorAll('[data-action]').forEach(btn=>btn.addEventListener('click',()=>{
   clear();
   if(btn.dataset.action!=='scan'){openOffer();return;}
   if(still()||document.hidden){if(scansEl)scansEl.textContent='0';show('result');openOffer();return;}
   show('scan');
   later(()=>{if(copyEl)copyEl.textContent='Reading the plate…';},430);
   later(()=>{if(scansEl)scansEl.textContent='0';show('result');resetCopy();},1150);
   later(openOffer,2250);
  }));
 });

 /* ---------- HOME FIX: inkopslista, steg och matthollet ---------- */
 const home=document.querySelector('.app-frame[data-app="home"]');
 if(home){
  const rows=Array.from(home.querySelectorAll('.buy-row input'));
  const tot=home.querySelector('[data-buy-total]'),cnt=home.querySelector('[data-buy-count]');
  const syncBuy=()=>{const on=rows.filter(r=>r.checked);
   const sum=on.reduce((s,r)=>s+(Number(r.dataset.amount)||0),0);
   if(tot)tot.textContent=eur(sum);if(cnt)cnt.textContent=String(on.length);};
  rows.forEach(r=>r.addEventListener('change',syncBuy));syncBuy();

  const steps=Array.from(home.querySelectorAll('[data-step]'));
  const bar=home.querySelector('[data-step-bar]'),sc=home.querySelector('[data-step-count]');
  const syncSteps=()=>{const n=steps.filter(s=>s.checked).length;
   if(bar)bar.style.width=(n/steps.length*100)+'%';
   if(sc)sc.textContent=n+' of '+steps.length;};
  steps.forEach(s=>s.addEventListener('change',syncSteps));syncSteps();

  const WIDTH=77; /* KALLAX 77 cm - banken ar shelfens langsida */
  const fi=home.querySelector('[data-fit-input]'),fo=home.querySelector('[data-fit-out]');
  const syncFit=()=>{if(!fi||!fo)return;
   const w=fi.valueAsNumber;
   if(!Number.isFinite(w)){fo.textContent='Enter your wall in cm';fo.setAttribute('data-bad','true');return;}
   const d=Math.round(w-WIDTH);
   fo.textContent=d>=0?('Fits with '+d+' cm spare'):('Too tight by '+Math.abs(d)+' cm');
   fo.setAttribute('data-bad',String(d<0));};
  if(fi){fi.addEventListener('input',syncFit);syncFit();}
 }

 /* ---------- OUR OWN WEDDING: svaren driver kostnad per gast ---------- */
 const wed=document.querySelector('.app-frame[data-app="wed"]');
 if(wed){
  const PER=7200,FIXED=420000+190000+115000,CAP=1200000,START=61,POOL=13;
  let yes=START;
  const q=s=>wed.querySelector(s);
  const syncWed=()=>{
   const food=yes*PER,total=food+FIXED,left=CAP-total;
   const set=(sel,v)=>{const el=q(sel);if(el)el.textContent=v;};
   set('[data-rsvp-yes]',String(yes));
   set('[data-rsvp-wait]',String(POOL-(yes-START)));
   set('[data-wed-guests]',yes+' × '+whole(PER));
   set('[data-wed-food]',whole(food));
   set('[data-wed-total]',whole(total));
   const le=q('[data-wed-left]');
   if(le){le.textContent=(left<0?'−':'')+whole(Math.abs(left));le.setAttribute('data-over',String(left<0));}
   const bw=q('[data-wed-bar]');
   if(bw){bw.style.setProperty('--pct',pct(total,CAP));bw.setAttribute('data-over',String(left<0));}
   wed.querySelectorAll('[data-rsvp]').forEach(b=>{
    const step=Number(b.dataset.rsvp);
    b.disabled=(step>0&&yes>=START+POOL)||(step<0&&yes<=START);});
  };
  wed.querySelectorAll('[data-rsvp]').forEach(b=>b.addEventListener('click',()=>{
   const n=yes+Number(b.dataset.rsvp);
   if(n<START||n>START+POOL)return;
   yes=n;syncWed();}));
  syncWed();
 }

 /* ---------- SOLO MONTH: kuverten och prenumerationsgranskningen ---------- */
 const money=document.querySelector('.app-frame[data-app="money"]');
 if(money){
  const DAYS=9;
  const envs=Array.from(money.querySelectorAll('[data-env]'));
  const safe=money.querySelector('[data-safe]'),pot=money.querySelector('[data-safe-pot]'),
        days=money.querySelector('[data-safe-days]');
  const syncEnv=()=>{
   let sum=0;
   envs.forEach(li=>{
    const left=Number(li.dataset.left)||0,total=Number(li.dataset.total)||1;
    sum+=left;
    const l=li.querySelector('[data-env-left]');if(l)l.textContent=whole(left);
    const b=li.querySelector('[data-env-bar]');if(b)b.style.setProperty('--pct',pct(left,total));
    const btn=li.querySelector('[data-spend]');
    if(btn)btn.disabled=left<Number(btn.dataset.spend);
   });
   if(pot)pot.textContent=whole(sum);
   if(days)days.textContent=String(DAYS);
   if(safe)safe.textContent=whole(Math.floor(sum/DAYS/100)*100);
  };
  envs.forEach(li=>{const btn=li.querySelector('[data-spend]');if(!btn)return;
   btn.addEventListener('click',()=>{
    const cost=Number(btn.dataset.spend)||0,left=Number(li.dataset.left)||0;
    if(left<cost)return;
    li.dataset.left=String(left-cost);syncEnv();});});
  syncEnv();

  const subs=Array.from(money.querySelectorAll('[data-sub]'));
  const asum=money.querySelector('[data-audit-sum]'),an=money.querySelector('[data-audit-n]');
  const syncSubs=()=>{
   const done=subs.filter(s=>s.dataset.done==='true');
   const freed=done.reduce((s,li)=>s+(Number(li.dataset.amount)||0),0);
   if(asum)asum.textContent=eur(freed);
   if(an)an.textContent=String(subs.length-done.length);
  };
  subs.forEach(li=>{const btn=li.querySelector('[data-cancel]');if(!btn)return;
   btn.addEventListener('click',()=>{
    li.dataset.done='true';btn.disabled=true;btn.textContent='Cancelled';syncSubs();});});
  syncSubs();
 }
})();

}catch(e){console.warn("[mdp] block skipped:",e&&e.message)}

;

try{

/* Bada ledtradarna ar engangsbruk: nar besokaren vet att det gar att trycka
   behover de inte staa kvar. Ingen lagring - per sidvisning racker. */
(()=>{'use strict';
 const b=document.body;
 document.querySelectorAll('.concept-tabs button').forEach(t=>
  t.addEventListener('click',()=>b.classList.add('concepts-touched'),{once:true}));
 document.querySelectorAll('.app-frame').forEach(f=>
  f.addEventListener('click',e=>{
   if(e.target.closest('button,input,label,a,[role=tab]'))b.classList.add('app-touched');
  }));
})();

}catch(e){console.warn("[mdp] block skipped:",e&&e.message)}

;

try{

(()=>{'use strict';
 /* RUNWAY: de tre valen flyttar samma tal. Allt raknas, inget ar hardkodat. */
 const rw=document.querySelector('.app-frame[data-app="money"]');
 if(rw){
  const BASE=31,TOTAL=52;
  const moves=Array.from(rw.querySelectorAll('[data-move]'));
  const week=rw.querySelector('[data-rw-week]'),gap=rw.querySelector('[data-rw-gap]'),
        bar=rw.querySelector('[data-rw-bar]');
  const syncRunway=()=>{
   const extra=moves.filter(b=>b.getAttribute('aria-pressed')==='true')
                    .reduce((s,b)=>s+(Number(b.dataset.move)||0),0);
   const w=Math.min(TOTAL,BASE+extra);
   if(week)week.textContent=String(w);
   if(gap)gap.textContent=String(TOTAL-w);
   if(bar)bar.style.setProperty('--pct',(w/TOTAL*100).toFixed(1)+'%');
  };
  moves.forEach(b=>b.addEventListener('click',()=>{
   b.setAttribute('aria-pressed',String(b.getAttribute('aria-pressed')!=='true'));
   syncRunway();}));
  syncRunway();
 }
})();

}catch(e){console.warn("[mdp] block skipped:",e&&e.message)}
